import _ from "lodash";
import { IApiResponse, IErrorResponse } from "model";
import { AlertActions } from "redux/actions";
import configureStore from "redux/configurations/configureStore";
import { I18nTranslator, translations } from "utils/i18n";

export enum EAlertType {
  ERROR = "error",
  WARNING = "warning",
  INFO = "info",
  SUCCESS = "success",
}

export const showAlert = (message: string, type: EAlertType) => {
  configureStore().store.dispatch(
    AlertActions.showAlert.request({ message, type })
  );
};
export const closeAlert = () => {
  configureStore().store.dispatch(AlertActions.closeAlert.request());
};
export const showError = (error: IErrorResponse | IApiResponse<any>) => {
  showAlert(
    _.isEmpty(error.message)
      ? I18nTranslator(translations.errorMessage.unknownError)
      : error.message[0].Text,
    EAlertType.ERROR
  );
};
